var map = {
	"./dashboard.svg": "f782",
	"./example.svg": "30c3",
	"./eye-open.svg": "d7ec",
	"./eye.svg": "4df5",
	"./form.svg": "eb1b",
	"./link.svg": "18f0",
	"./nested.svg": "dcf8",
	"./password.svg": "2a3d",
	"./table.svg": "47f1",
	"./tree.svg": "93cd",
	"./user.svg": "b3b5"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "51ff";